export interface IPatientInvoiceDetailDTO {
  id?: number
  invoiceNumber?: number
  groupNumber?: number
  dos?: Date
  invoiceDate?: Date
  dateForRush?: Date
  rsId?: number
  rscontactId?: number
  typeCode?: string
  providerId?: number
  apptStatus?: string
  numberOfHours?: number
  billingPricePerHour?: number
  invoiceAmount?: number
  amountPaid?: number
  invoiceSpecificText?: string
  paidInFull?: boolean
}

export class PatientInvoiceDetailDTO implements IPatientInvoiceDetailDTO {
  public id?: number
  public invoiceNumber?: number
  public groupNumber?: number
  public dos?: Date
  public invoiceDate?: Date
  public dateForRush?: Date
  public rsId?: number
  public rscontactId?: number
  public typeCode?: string
  public providerId?: number
  public apptStatus?: string
  public numberOfHours?: number
  public billingPricePerHour?: number
  public invoiceAmount?: number
  public amountPaid?: number
  public invoiceSpecificText?: string
  public paidInFull?: boolean
}
